import { DefaultModelProperty, LabelValue } from '../standard'
import CuratedMediaList from './curated-media-list-model'
import curatedMediaListProperties from './curatedMediaList-properties'
import { CuratedMediaListProperties } from './curatedMediaList-property-definitions'

export async function OnEvents(
  eventType: string,
  form: CuratedMediaList,
  property: CuratedMediaListProperties,
): Promise<CuratedMediaList> {
  switch (eventType) {
    case 'change':
      return await change(property, form)

    default:
      break
  }
  return form
}
export function IsDisabled(property: CuratedMediaListProperties): boolean {
  switch (property) {
    default:
      return false
  }
}

export function IsVisible(property: CuratedMediaListProperties): boolean {
  switch (property) {
    case CuratedMediaListProperties.Owner:
      return false
    case CuratedMediaListProperties.Id:
      return false
    case CuratedMediaListProperties.Created:
      return false
    case CuratedMediaListProperties.Updated:
      return false
    case CuratedMediaListProperties.Deleted:
      return false
    case CuratedMediaListProperties.Version:
      return false
    case CuratedMediaListProperties.ProcessedMedia:
      return false
    case CuratedMediaListProperties.Released:
      return false
    case CuratedMediaListProperties.Media:
      return false
    default:
      return true
  }
}
async function change(
  property: CuratedMediaListProperties,
  value: CuratedMediaList,
): Promise<CuratedMediaList> {
  switch (property) {
    default:
      return value
  }
  return value
}
function getModelProperties(): DefaultModelProperty<CuratedMediaListProperties>[] {
  return curatedMediaListProperties as DefaultModelProperty<CuratedMediaListProperties>[]
}
export function GetPageProperties(): DefaultModelProperty<CuratedMediaListProperties>[] {
  function getPagePropertyPosition(property: string) {
    switch (property) {
      default:
        return 20
    }
  }
  return AssignUIComponent(
    getModelProperties()
      .filter((x: DefaultModelProperty<CuratedMediaListProperties>) => {
        return getPagePropertyPosition(x.name) !== -1
      })
      .sort((a, b) => {
        return getPagePropertyPosition(a.name) - getPagePropertyPosition(b.name)
      })
      .map((v: DefaultModelProperty<CuratedMediaListProperties>) => {
        return v
      }),
  )
}

export function DropdownOptions(
  property: CuratedMediaListProperties,
): LabelValue<any>[] {
  switch (property) {
    default:
      return []
      break
  }
  return []
}
export function IsRequired(property: CuratedMediaListProperties): boolean {
  switch (property) {
    case CuratedMediaListProperties.Owner:
      return false
    case CuratedMediaListProperties.Id:
      return false
    case CuratedMediaListProperties.Created:
      return false
    case CuratedMediaListProperties.Updated:
      return false
    case CuratedMediaListProperties.Deleted:
      return false
    case CuratedMediaListProperties.Version:
      return false
    case CuratedMediaListProperties.ProcessedMedia:
      return false
    case CuratedMediaListProperties.Released:
      return false
    case CuratedMediaListProperties.Media:
      return false
    default:
      return true
  }
}
export function AssignUIComponent(
  properties: DefaultModelProperty<CuratedMediaListProperties>[],
): DefaultModelProperty<CuratedMediaListProperties>[] {
  return properties.map(
    (modelProperty: DefaultModelProperty<CuratedMediaListProperties>) => {
      switch (modelProperty.name) {
        default:
          break
      }
      return modelProperty
    },
  )
}
